let bank = {};

bank = require('../data/bank')

module.exports = bank;